import React from 'react';
import PropTypes from 'prop-types';
import { Design } from 'apps/find-designers/propTypes';

const DesignGalleryItem = ({ designerId, design }) => {
    const designUrl = `/profiles/${designerId}/designs/${design.id}`;

    return (
        <div className="mediabox mediabox--linked">
            <a
                className="mediabox__media-frame mediabox__media-frame--fullscreen"
                href={designUrl}
                rel="nofollow"
                style={{
                    paddingBottom: '100%',
                    overflow: 'hidden',
                    position: 'relative',
                }}
            >
                <picture
                    style={{
                        position: 'absolute',
                        display: 'block',
                        height: '100%',
                        width: '100%',
                    }}
                >
                    <source
                        srcSet={`${design.imageSources.smallCrop}, ${
                            design.imageSources.largeCrop
                        } 2x`}
                        type="image/jpeg"
                        media="(min-width: 600px)"
                    />
                    <source srcSet={design.imageSources.original} type="image/webp" />
                    <img
                        className="mediabox__media"
                        alt={design.title}
                        title={design.description}
                        src={design.imageSources.largeCrop}
                        data-profile-design
                    />
                </picture>
            </a>
        </div>
    );
};

DesignGalleryItem.propTypes = {
    designerId: PropTypes.number,
    design: Design.isRequired,
};

export default DesignGalleryItem;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/DesignGalleryItem.jsx